<template>
  <div>
    <Navbar activeDirectory="admin" activePage="admin-users"></Navbar>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <button class="btn btn-secondary mb-2 btn-sm" @click="mode='add'; user={fullname: '', email: '', group: 'B'}">Aggiungi Nuovo</button>
          <div class="card" v-if="mode=='read'">
            <div class="card-body">

              <table class="table table-striped">
                <thead>
                  <th>Utente</th>
                  <th>Email</th>
                  <th>Gruppo</th>
                  <th></th>
                </thead>

                <tbody>
                  <tr v-for="item in this.users" v-bind:key="item.id">
                    <td>{{ item.fullname }}</td>
                    <td>{{ item.email }}</td>
                    <td>
                      <span
                        class="badge"
                        :class="[{'badge-primary': item.group == 'B'}, {'badge-secondary' : item.group == 'G'}]"
                      >{{ item.group == 'B'? 'AMMINISTRATORE' : 'GEOMETRA' }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-sm btn-primary"
                        @click="mode='edit'; user=item;"
                      >Gestisci</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card" v-if="mode=='edit'">
            <div class="card-body">
             
              <div class="form-group">
                <label class="font-bold pull-left">Nome completo</label>
                <input v-model="user.fullname" class="form-control" placeholder="Nome completo">
              </div> 

              <div class="form-group">
                <label class="font-bold pull-left">Email</label>
                <input v-model="user.email" class="form-control" type="email" placeholder="Email" readonly>
              </div> 

              <div class="form-group">
                <label class="font-bold pull-left">Gruppo</label>
                <select v-model="user.group" class="form-control">
                  <option value="B">AMMINISTRATORE</option>
                  <option value="G">GEOMETRA</option>
                </select>
              </div> 
                 
              <button class="btn btn-success pull-right btn-sm" @click="updateUser()">Aggiorna Informazioni</button>
              <button class="btn btn-secondary pull-right btn-sm mr-2" @click="mode='read'">Torna Indietro</button>
              <button class="btn btn-warning pull-right btn-sm mr-2" @click="passwordReset()">Rigenera Password</button>
            </div>            
          </div>
          <div class="card" v-if="mode=='add'">
            <div class="card-body">
             
              <div class="form-group">
                <label class="font-bold pull-left">Nome completo</label>
                <input v-model="user.fullname" class="form-control" placeholder="Nome completo">
              </div> 

              <div class="form-group">
                <label class="font-bold pull-left">Email</label>
                <input v-model="user.email" class="form-control" type="email" placeholder="Email">
              </div> 

              <div class="form-group">
                <label class="font-bold pull-left">Gruppo</label>
                <select v-model="user.group" class="form-control">
                  <option value="B">AMMINISTRATORE</option>
                  <option value="G">GEOMETRA</option>
                </select>
              </div> 
                 
              <button class="btn btn-success pull-right btn-sm" @click="saveUser()">Aggiungi Utente</button>
              <button class="btn btn-secondary pull-right btn-sm mr-2" @click="mode='read'">Torna Indietro</button>
            </div>            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      tipologia: localStorage.getItem("tipologia"),
      users: [],
      user: undefined,
      mode: "read",
    };
  },

  watch: {
    mode(nv) {
      if (nv == "read") {
        this.fetchUsers();
      } 
    },
  },

  mounted() {
    if (this.tipologia != "B") {
      this.$router.push({ name: "home" });
    } else {
      this.fetchUsers();
    }
  },

  methods: {
    /**
     * fetchUsers
     *
     * Get the list of users
     *
     * Returns the list of the users (ADMIN = B and GEOMETRA = G)
     *
     * 2020-08-25 [fmarigliano@bidata.it] - Method creation
     */
    fetchUsers() {
      this.axios.get("/get-users").then((response) => {
        this.users = response.data;
      });
    },

    /**
     * saveUser
     * 
     * Save new user
     * 
     * No returns
     * 
     * 2020-08-25 [fmarigliano@bidata.it] - Method creation
     */
    saveUser() {
      var formData = new FormData()
      formData.append('email', this.user.email)
      formData.append('fullname', this.user.fullname)
      formData.append('group', this.user.group)
      this.axios.post("/subscribe", formData).then(response=>{
        if(response.data['success']){
          this.mode='read';
        }
      })
    },

    /**
     * updateUser
     * 
     * Update user data
     * 
     * No returns
     * 
     * 2020-08-25 [fmarigliano@bidata.it] - Method creation
     */
    updateUser() {
      var formData = new FormData()
      formData.append('id', this.user.id)
      formData.append('email', this.user.email)
      formData.append('fullname', this.user.fullname)
      formData.append('group', this.user.group)
      this.axios.post("/user/update", formData).then(response=>{
        if(response.data['success']){
          this.mode='read';
        }
      })
    },

    /**
     * passwordReset
     * 
     * Reset user password
     * 
     * No returns
     * 
     * 2020-08-25 [fmarigliano@bidata.it] - Method creation
     */
    passwordReset() {
      var formData = new FormData()
      formData.append('id', this.user.id)
      this.axios.post("/password-regeneration", formData).then(response=>{
        if(response.data['success']){
          this.mode='read';
        }
      })
    }
  },
};
</script>

<style>
</style>